import React, { useEffect, useState } from 'react';
import L from 'leaflet'; // Импорт библиотеки Leaflet
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from 'react-leaflet';
import { getCookie } from 'typescript-cookie';
import KyLokal from '../../changeLang/drawLocalesKy';
import RuLokal from '../../changeLang/drawLocalesRu';
import styles from "./styles_map.module.css";

interface IContentPart {
  latitude: number;
  longitude: number;
}

const markers = [
  {
    latitude: 42.875969,
    longitude:  74.603701,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Чуйская область</h3>
      <p style="margin: 4px 0;">
        <strong>Птицы:</strong> 2724210 голов<br />
        <strong>КРС:</strong> 314181 голов<br />
        <strong>Коровы:</strong> 149421 голов<br />
        <strong>Лошади:</strong> 78142 голов<br />
        <strong>Овцы:</strong> 78142 голов<br />
        <strong>Свиньи:</strong> 78142 голов<br />
      </p>
      </div>
    `
  },
  {
    latitude:40.315997,
    longitude:  73.439965  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ошская область</h3>
      <p style="margin: 4px 0;">
        <strong>Птицы:</strong> 103838 голов<br />
        <strong>КРС:</strong> 397288 голов<br />
        <strong>Коровы:</strong> 199253 голов<br />
        <strong>Лошади:</strong> 98572 голов<br />
        <strong>Овцы:</strong> 1121452 голов<br />
        <strong>Свиньи:</strong> 0 голов<br />
      </p>
      </div>
    `
  },
  {
    latitude: 41.428298, 
    longitude: 75.997628,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Нарынская область</h3>
      <p style="margin: 4px 0;">
        <strong>Птицы:</strong> 213064 голов<br />
        <strong>КРС:</strong> 207043 голов<br />
        <strong>Коровы:</strong> 93366 голов<br />
        <strong>Лошади:</strong> 142493 голов<br />
        <strong>Овцы:</strong> 1127887 голов<br />
        <strong>Свиньи:</strong> 0 голов<br />
      </p>
      </div>
    `
  },
  {
    latitude: 42.491147, 
    longitude: 78.399567,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ысык-Кульская область</h3>
      <p style="margin: 4px 0;">
        <strong>Птицы:</strong> 624745 голов<br />
        <strong>КРС:</strong> 272647 голов<br />
        <strong>Коровы:</strong> 138616 голов<br />
        <strong>Лошади:</strong> 94258 голов<br />
        <strong>Овцы:</strong> 917653 голов<br />
        <strong>Свиньи:</strong> 1106 голов<br />
      </p>
      </div>
    `
  }, 
  {
    latitude: 40.060518, 
    longitude: 70.819629,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Баткенская область</h3>
      <p style="margin: 4px 0;">
       <strong>Птицы:</strong> 265104 голов<br />
        <strong>КРС:</strong> 144851 голов<br />
        <strong>Коровы:</strong> 69878 голов<br />
        <strong>Лошади:</strong> 6763 голов<br />
        <strong>Овцы:</strong> 415756 голов<br />
        <strong>Свиньи:</strong> 68 голов<br />
      </p>
      </div>
    `
  },
  {
    latitude: 41.802703, 
    longitude: 71.958225  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Джалал-Абадская область</h3>
      <p style="margin: 4px 0;">
       <strong>Птицы:</strong> 1188737 голов<br />
        <strong>КРС:</strong> 371686 голов<br />
        <strong>Коровы:</strong> 198462 голов<br />
        <strong>Лошади:</strong> 94258 голов<br />
        <strong>Овцы:</strong> 919653 голов<br />
        <strong>Свиньи:</strong> 118 голов<br />
      </p>
      </div>
    `
  },  {
    latitude: 42.520755, 
    longitude: 72.250591,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Таласская область</h3>
      <p style="margin: 4px 0;">
       <strong>Птицы:</strong> 261790 голов<br />
        <strong>КРС:</strong> 314181 голов<br />
        <strong>Коровы:</strong> 33965 голов<br />
        <strong>Лошади:</strong> 28604 голов<br />
        <strong>Овцы:</strong> 565146 голов<br />
        <strong>Свиньи:</strong> 75 голов<br />
      </p>
      </div>
    `
  }
  
  
];

const customMarkerIcon = L.icon({
  iconUrl: '/krc.svg', 
  iconSize: [35, 55],
  iconAnchor: [12, 41], 
  popupAnchor: [1, -34], 
});

export const AnimalKrcMap = (props: IContentPart, ) => {
  (L as any).drawLocal = getCookie('i18next') === 'ky' ? KyLokal : RuLokal;



  const [geoData, setGeoData] = useState<any>(null);
  const [bishkekGeoData, setBishkekGeoData] = useState<any>(null);
  const [batkenGeoData, setBatkenGeoData] = useState<any>(null);
  const [chuiGeoData, setChuiGeoData] = useState<any>(null);
  const [issikulGeoData, setIssikulGeoData] = useState<any>(null);
  const [jalalabadGeoData, setJalalabadGeoData] = useState<any>(null);
  const [narinGeoData, setNarinGeoData] = useState<any>(null);
  const [oshGeoData, setOshGeoData] = useState<any>(null);
  const [oshoblGeoData, setOshoblGeoData] = useState<any>(null);
  const [talasGeoData, setTalasGeoData] = useState<any>(null);
  useEffect(() => {
 
    const fetchGeoData = async (file: string, setGeoData: React.Dispatch<React.SetStateAction<any>>, label: string) => {
      try {
        const response = await fetch(`/${file}`);
      
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
      
        if (data[0] && data[0].geojson) {
     
          setGeoData(data[0].geojson);
        } else {
          console.warn(`Данные geojson отсутствуют или неверный формат в ${label}:`, data);
        }
      } catch (error) {
        console.error(`Ошибка загрузки данных из ${label}:`, error);
      }
    };

   

    fetchGeoData('polygons/search.json', setGeoData, 'polygons/search.json');
    fetchGeoData('polygons/bishkek.json', setBishkekGeoData, 'polygons/bishkek.json');
    fetchGeoData('polygons/batken.json', setBatkenGeoData, 'polygons/batken.json');
    fetchGeoData('polygons/chui.json', setChuiGeoData, 'polygons/chui.json');
    fetchGeoData('polygons/issikul.json', setIssikulGeoData, 'polygons/issikul.json');
    fetchGeoData('polygons/jalalabad.json', setJalalabadGeoData, 'polygons/jalalabad.json');
    fetchGeoData('polygons/narin.json', setNarinGeoData, 'polygons/narin.json');
    fetchGeoData('polygons/osh.json', setOshGeoData, 'polygons/osh.json');
    fetchGeoData('polygons/oshobl.json', setOshoblGeoData, 'polygons/oshobl.json');
    fetchGeoData('polygons/talas.json', setTalasGeoData, 'polygons/talas.json');

  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  return (
    <MapContainer
      className={styles.map}
      center={[41.5089324, 74.724091]}
      zoom={6}
      minZoom={6}
      scrollWheelZoom={true}
      zoomControl={false}
    >
      <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      {/* {geoData && <GeoJSON data={geoData} style={getStyle('blue')} onEachFeature={onEachFeature} />} */}
      
      {markers.map((marker, index) => (
        <Marker key={index} position={[marker.latitude, marker.longitude]} icon={customMarkerIcon}>
          <Popup>
            <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
          </Popup>
        </Marker>
      ))}
           {/* {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />} */}
           {bishkekGeoData && <GeoJSON data={bishkekGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {batkenGeoData && <GeoJSON data={batkenGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {chuiGeoData && <GeoJSON data={chuiGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {issikulGeoData && <GeoJSON data={issikulGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {jalalabadGeoData && <GeoJSON data={jalalabadGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {narinGeoData && <GeoJSON data={narinGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {/* {oshGeoData && <GeoJSON data={oshGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />} */}
      {oshoblGeoData && <GeoJSON data={oshoblGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {talasGeoData && <GeoJSON data={talasGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
    </MapContainer>
  );
};
